import React, { Fragment, useContext } from "react";
import { Button } from "../components/Button";
import { Paging } from "../components/Paging";
import { Table, TableHead, TableBody, Col, HeaderCell } from "../components/Table";
import { LoadingSpinner } from "../components/LoadingSpinner";
import "./SearchResults.css";
import { FormattedMessage } from "react-intl";
import MunicipalityContext from "../MunicipalityContext";
import { booleanOptions } from "../constants";

export function NameStampSearchResults({
  changePage,
  currentPage,
  pageSize,
  results,
  searching,
  searchError,
  sortColumn,
  sortDirection,
  totalRows,
  updateSort,
  locale,
  searchResultNameStampRef
}) {
  const municipalities = useContext(MunicipalityContext);

  const spinner = (
    <div className='spinnerContainer'>
      <LoadingSpinner />
    </div>
  );
  if (!searching && !results) return "";

  if (searchError) {
    return (
      <div className='searchError'>
        <FormattedMessage id='nameStampSearch.searchError' />
      </div>
    );
  }

  const municipalityNames = municipalities.reduce((obj, municipality) => {
    obj[municipality.kuntaKoodi] =
      locale === "fi" ? municipality.kuntaNimi : municipality.kuntaNimiSv;
    return obj;
  }, {});

  const paging = (
    <Paging
      itemsLength={totalRows}
      perPage={pageSize}
      activePage={currentPage}
      changePage={changePage}
    >
      {({ totalPages, activePage, goBack, goForward }) => (
        <div className='paging'>
          <Button link onClick={goBack} disabled={activePage === 0}>
            <FormattedMessage id='common.previous' />
          </Button>
          <div className='pagesCount'>
            {activePage + 1} / {totalPages || 1}
          </div>
          <Button link onClick={goForward} disabled={activePage >= totalPages - 1}>
            <FormattedMessage id='common.next' />
          </Button>
        </div>
      )}
    </Paging>
  );

  const drawResultsHeadingFinished = (
    <div className='resultHeading' aria-live='assertive'>
      <FormattedMessage
        id='nameStampSearch.results'
        values={{
          results: <span className='resultCount'>{totalRows}</span>,
        }}
      />
    </div>
  );

  const drawResultsHeadingSearching = (
    <div className='resultHeading'>
      <FormattedMessage id='common.searching' />
    </div>
  );

  const textOrImage = ({ text, image }) => {
    if (image === null || image === "") {
      return text;
    }

    return <img className='name-stamp-image' src={image} alt={text}></img>;
  };

  const imageText = ({ text, image }) => {
    if (image === null || image === "") {
      return "";
    }

    return <span>{text}</span>;
  };

  const isInUseText = isInUse => {
    const option = booleanOptions.find(o => o.value === JSON.stringify(isInUse));
    return <FormattedMessage id={option.label} />;
  };

  const formatDate = (locale, date) => {
    if (date === null) {
      return ""
    }
    else {
      return new Intl.DateTimeFormat(locale, {}).format(new Date(date));
    }
  };

  return (
    <Fragment>
      {searching ? drawResultsHeadingSearching : drawResultsHeadingFinished}
      {paging}
      <Table ref={searchResultNameStampRef}>
        <TableHead sortColumn={sortColumn} sortDirection={sortDirection} updateSort={updateSort}>
          <HeaderCell disabled name='code' />
          <HeaderCell name='text'>
            <FormattedMessage id='nameStampSearch.code' />
          </HeaderCell>
          <HeaderCell name='companyText'>
            <FormattedMessage id='common.companyOrPractitioner' />
          </HeaderCell>
          <HeaderCell name='municipality'>
            <FormattedMessage id='common.municipality' />
          </HeaderCell>
          <HeaderCell name='validityStart'>
            <FormattedMessage id='nameStampSearch.validityStart' />
          </HeaderCell>
          <HeaderCell name='validityEnd'>
            <FormattedMessage id='common.validityEnd' />
          </HeaderCell>
          <HeaderCell name='isInUse'>
            <FormattedMessage id='nameStampSearch.isInUse' />
          </HeaderCell>
        </TableHead>
        {searching ? (
          <tbody>
            <tr>
              <td colSpan='5'>{spinner}</td>
            </tr>
          </tbody>
        ) : (
          <TableBody rows={results}>
            {rows =>
              rows.map((row, i) => (
                <tr key={`row_${i}`}>
                  <Col>{imageText(row)}</Col>
                  <Col label='nameStampSearch.code'>{textOrImage(row)}</Col>
                  <Col label='common.companyOrPractitioner'>{row.companyText}</Col>
                  <Col label='common.municipality'>{municipalityNames[row.municipality]}</Col>
                  <Col label='nameStampSearch.validityStart'>{formatDate("fi-FI", row.validityStart)}</Col>
                  <Col label='nameStampSearch.validityEnd'>{formatDate("fi-FI", row.validityEnd)}</Col>
                  <Col label='nameStampSearch.isInUse'>{isInUseText(row.isInUse)}</Col>
                </tr>
              ))
            }
          </TableBody>
        )}
      </Table>
      {paging}
      </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/NameStampSearch/NameStampSearchResults.js